import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../problems/problem.service';
import { TaskGtNetLinkResponseInterface } from './definitions/task-gt-net-link-response-interface';

@Injectable()
export class TaskGetGtNetLinkService {
  constructor(private client: HttpClient, private configService: ConfigService) {}

  public getGtNetLink(taskId: string): Observable<TaskGtNetLinkResponseInterface> {
    const url = `${this.configService.config.rest.apiV2Url}/tasks/${taskId}/gtnet-link`;

    return this.client.get<TaskGtNetLinkResponseInterface>(url).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
